import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';

import App from './App';
import * as serviceWorker from './serviceWorker';
import applyPolyfills from './utils/polyfills';
import { getSentryEnvironment } from './utils/sentryHelpers';

import 'styles/index.css';

const environment = getSentryEnvironment();
Sentry.init({
  dsn: 'https://53972fda1b8f49839e7496a177662dc7@sentry.taf.nl/4',
  release: 'questionnairesurveyor@1.3.44',
  environment: environment,
  enabled: environment !== 'development',
  integrations: [new BrowserTracing()],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
});


applyPolyfills();

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('No root element found');
}

const root = createRoot(rootElement);
root.render(
  <>
    <App />
  </>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
